import React from 'react';
import { Alert, Box, Button, Checkbox, FormControlLabel, Grid, Link, Paper, Snackbar, Stack, TextField, Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateField } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import Service from '../../util/Service';

export default function CadastrarUsuario2() {
    const [user, setUser] = React.useState();
    const [confirma, setConfirma] = React.useState('');
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [value, setValue] = React.useState();

    const [errorPass, setErroPass] = React.useState(false)

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    const onChangeUser = (e) => {
        limparErro();
        setUser({
            ...user,
            [e.target.name]: e.target.value
        })
    }
    function limparErro(){
        setErroPass(false);
    }
    const handleCelular=(e)=>{
        limparErro();
        var value = e.target.value;
        var r = value.replace(/\D/g, "");
        r = r.replace(/^0/, "");
        if (r.length > 10) {
            r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
        } else if (r.length > 5) {
            r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else if (r.length > 2) {
            r = r.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else {
            r = r.replace(/^(\d*)/, "($1");
        }
        e.target.value = r;
        setUser({
            ...user,
            cel: e.target.value
        })
    }
    const handleCriar=()=>{
        limparErro();
        if(value){
            user.dtExpiracao = value.toDate();
        }
        console.log( user );
        if( confirma !== user.password ){
            setErroPass(true);
            setOpen(true);
            setMsg("Confirmação da senha não bate");
            return;
        }

        Service.POST("/api/user/register", user).then(resp => {
            console.log(resp);
            navigate("/gerenciar/users");
        }).catch(error => {
            console.error(error);
        })
    }
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid container spacing={2}>
            <Grid size={6}>
                <Link href="../users" underline="none">Usuários </Link> » Novo usuário
            </Grid>
            <Grid size={6}>
                <Button variant="contained" onClick={handleCriar}>Criar Usuário</Button>
            </Grid>
            <Grid size={6}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom align='center'>
                        Informações
                    </Typography>
                    <Stack spacing={2}>
                        <TextField label="Login" name="login" required size="small" value={user?.login || ""}
                            onChange={onChangeUser}
                        />
                        <TextField label="Nome" name="nome" required size="small" value={user?.nome || ""}
                            onChange={onChangeUser}
                        />
                        <TextField label="Email" type='email' name="email" required size="small"  value={user?.email || ""}
                            onChange={onChangeUser}
                        />
                        <TextField label="Celular" name="cel" required size="small" value={user?.cel || ""}
                            onChange={handleCelular}
                        />
                        <TextField label="Área de trabalho" name="paginaHome" size="small" value={user?.paginaHome || ""}
                            onChange={onChangeUser}
                        />
                    </Stack>
                </Paper>
            </Grid>
            <Grid size={6}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom align='center'>
                        Autenticação
                    </Typography>
                    <Stack spacing={2}>
                        <TextField label="Senha"    type="password" size="small" autoComplete="current-password" helperText="Mínimo 8 caracteres."
                            name="password"
                            value={user?.password || ""}
                            onChange={onChangeUser}
                            placeholder="••••••"
                            error={errorPass}
                        />
                        <TextField label="Confirma" type="password" size="small" autoComplete="current-password" helperText="Confirma a senha"
                            name="confirma"
                            value={confirma}
                            onChange={(e)=>{setConfirma(e.target.value);limparErro()}}
                            placeholder="••••••"
                            error={errorPass}
                        />
                        <FormControlLabel control={<Checkbox 
                            checked={user?.changePass} onChange={(e)=> setUser({...user, changePass: e.target.checked})}
                        />} label="Alterar senha proximo login?" />
                        {/* <TextField label="Data expiração da senha" type="date" size="small"/> */}
                        <DateField 
                            size="small" label="Data expiração da senha" 
                            value={value}
                            onChange={(newValue) => setValue(newValue)}
                        />
                        <FormControlLabel control={<Checkbox 
                            checked={user?.twoFactor} onChange={(e)=> setUser({...user, twoFactor: e.target.checked})}
                        />} label="Autenticação em dois fatores" />
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity="warning"
                variant="filled"
                sx={{ width: '100%' }}
            >
                {msg}
            </Alert>
        </Snackbar>
        </LocalizationProvider>
    )
}